export default __webpack_public_path__ + "static/media/mastercard.dc3f6319.png";